import React, { createContext, useState, useMemo, useEffect, useCallback } from "react"

import useDataApi from "../hooks/useDataApi"
import { fnGetAllFields, fnUpdateField as fnUpdate } from "../services/activityFields"

export const FieldsContext = createContext(null)

export const FieldsContextProvider = ({ children }) => {
  const [oAllFieldsRes, fnGetAllFieldsReq] = useDataApi(fnGetAllFields)
  const [oUpdateFieldRes, fnUpdateFieldReq] = useDataApi(fnUpdate)
  const [aAllFields, fnSetAAllFields] = useState([])

  async function fnGetFields() {
    const response = await fnGetAllFieldsReq()
    fnSetAAllFields(prev => response?.data)
    return response
  }
  async function fnUpdateField(values) {
    const response = await fnUpdateFieldReq(values)
    if (response.data.success) {
      await fnGetFields()
    }
    return response
  }

  const value = useMemo(() => {
    return { oAllFieldsRes, fnGetFields, fnUpdateField, aAllFields, oUpdateFieldRes }
  }, [oAllFieldsRes, aAllFields])

  return <FieldsContext.Provider value={value}>{children}</FieldsContext.Provider>
}

export default FieldsContext
